med
<div class="content-tab">
  <h1 class="mb-3 title-overview">Medical folder</h1>
  <form [formGroup]="medicalForm" (ngSubmit)="onSubmit()">
    <div class="row card-info">
      <div class="col-12 col-lg-6">
        <h3 class="mb-3 subtitle">Basis informations</h3>
        <!-- <div class="form-group">
          <label class="lbl-patient fw-medium" for="msType">
            {{ "MEDICAL.SEP_TYPE" }}
          </label>
          <ng-select
            [items]="MSTypeMapping | keyvalue"
            bindLabel="value"
            bindValue="key"
            [placeholder]="'MEDICAL.SEP_TYPE_PLACEHOLDER'"
            formControlName="msType"
          >
            <ng-template ng-label-tmp let-item="item">
              {{ item.value }}
            </ng-template>
            <ng-template
              ng-option-tmp
              let-item="item"
              let-index="index"
              let-search="searchTerm"
            >
              {{ item.value }}
            </ng-template>
          </ng-select>
        </div> -->
        <div class="form-group">
          <label class="lbl-patient fw-medium" for="canWalkOneKm">
            <span i18n="@@patient_detail_medical_canWalk"
              >Périmètre de marche supérieur à 1 km</span
            >
          </label>
          <div
            class="btn-group btn-group-toggle"
            ngbRadioGroup
            name="canWalkOneKm"
            id="true"
          >
            <label
              ngbButtonLabel
              class="radio-form btn"
              [class.active]="
                medicalForm.get('canWalkOneKm').value === 'true' ||
                medicalForm.get('canWalkOneKm').value === true
              "
            >
              <input
                ngbButton
                type="radio"
                formControlName="canWalkOneKm"
                [value]="true"
              />
              <span i18n="@@patient_detail_medical_yes">Oui</span>
            </label>
            <label
              ngbButtonLabel
              class="radio-form btn right-radio"
              [class.active]="
                medicalForm.get('canWalkOneKm').value === 'false' ||
                medicalForm.get('canWalkOneKm').value === false
              "
            >
              <input
                ngbButton
                type="radio"
                formControlName="canWalkOneKm"
                [value]="false"
              />
              <span i18n="@@patient_detail_medical_no">Non</span>
            </label>
          </div>
        </div>
        <div class="form-group">
          <label class="lbl-patient fw-medium" for="edss"> EDSS Score </label>
          <ng-select
            [items]="edssChoice"
            id="edss"
            bindLabel="label"
            bindValue="value"
            placeholder="EDSS Score"
            formControlName="edss"
          >
            <ng-template ng-label-tmp let-item="item">
              {{ item.value }}
            </ng-template>
          </ng-select>
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <h3 class="mb-3 subtitle">First years</h3>
        <div class="form-group">
          <label class="lbl-patient fw-medium" for="diagnosticYear">
            Diagnostic year
          </label>
          <ng-select
            [items]="yearsList"
            bindLabel="value"
            bindValue="value"
            placeholder="YYYY"
            formControlName="diagnosticYear"
          ></ng-select>
        </div>
        <div class="form-group">
          <label class="lbl-patient fw-medium" for="firstYearRelapseCount">
            Relapses number while first year
          </label>
          <ng-select
            [items]="relapseMapping | keyvalue"
            bindLabel="value"
            bindValue="key"
            placeholder="Relapses number"
            formControlName="firstYearRelapseCount"
          >
            <ng-template ng-label-tmp let-item="item">
              {{ item.value }}
            </ng-template>
            <ng-template
              ng-option-tmp
              let-item="item"
              let-index="index"
              let-search="searchTerm"
            >
              {{ item.value }}
            </ng-template>
          </ng-select>
        </div>
        <div class="form-group">
          <label class="lbl-patient fw-medium" for="firstYearOfSymptoms">
            First year of symptoms
          </label>
          <ng-select
            [items]="yearsList"
            bindLabel="value"
            bindValue="value"
            placeholder="YYYY"
            formControlName="firstYearOfSymptoms"
          ></ng-select>
        </div>
      </div>
    </div>

    <div class="row card-info">
      <h3 class="mb-3 subtitle">
        <span i18n="@@patient_detail_medical_title_help">Aide à la marche</span>
      </h3>
      <div class="walking-aid">
        <div
          (click)="toggleAidStick()"
          class="aid"
          [class.aid-active]="medicalForm.get('walkingStickAid').value === true"
          [class.aid-inactive]="
            medicalForm.get('walkingStickAid').value === false
          "
        >
          <img
            class="icon"
            [class.uncheck-icon]="
              medicalForm.get('walkingStickAid').value === false
            "
            src="assets/icons/icon-walking-aid-widget-check.svg"
            alt="aid-1"
          />
          <div
            class="aid-center"
            [class.unchecked]="
              medicalForm.get('walkingStickAid').value === false
            "
          >
            <img
              [class.aid-active]="
                medicalForm.get('walkingStickAid').value === true
              "
              [src]="
                medicalForm.get('walkingStickAid').value === true
                  ? 'assets/icons/icone-widget-aide-canne-active.svg'
                  : 'assets/icons/icone-widget-aide-canne-unactive.svg'
              "
              alt="aid-1"
            /><br />
            <span
              [class.aid-active]="
                medicalForm.get('walkingStickAid').value === true
              "
              [class.aid-inactive]="
                medicalForm.get('walkingStickAid').value === false
              "
              i18n="@@patient_detail_medical_walkingStickAid"
            >
              canne</span
            >
          </div>
        </div>
        <div
          class="aid"
          (click)="toggleAidCrutches()"
          [class.aid-active]="medicalForm.get('crutchesAid').value === true"
          [class.aid-inactive]="medicalForm.get('crutchesAid').value === false"
        >
          <img
            class="icon"
            [class.uncheck-icon]="
              medicalForm.get('crutchesAid').value === false
            "
            src="assets/icons/icon-walking-aid-widget-check.svg"
            alt="aid-1"
          />
          <div
            class="aid-center"
            [class.unchecked]="medicalForm.get('crutchesAid').value === false"
          >
            <img
              [src]="
                medicalForm.get('crutchesAid').value === true
                  ? 'assets/icons/icone-widget-aide-deux-cannes-active.svg'
                  : 'assets/icons/icone-widget-aide-deux-cannes-unactive.svg'
              "
              alt="aid-2"
            /><br />
            <span
              [class.aid-active]="medicalForm.get('crutchesAid').value === true"
              [class.aid-inactive]="
                medicalForm.get('crutchesAid').value === false
              "
              i18n="@@patient_detail_medical_crutchesAid"
              >deux cannes</span
            >
          </div>
        </div>
        <div
          class="aid"
          (click)="toggleAidWalkWith()"
          [class.aid-active]="
            medicalForm.get('walkWithCaregiverAid').value === true
          "
          [class.aid-inactive]="
            medicalForm.get('walkWithCaregiverAid').value === false
          "
        >
          <img
            class="icon"
            [class.uncheck-icon]="
              medicalForm.get('walkWithCaregiverAid').value === false
            "
            src="assets/icons/icon-walking-aid-widget-check.svg"
            alt="aid-1"
          />
          <div
            class="aid-center"
            [class.unchecked]="
              medicalForm.get('walkWithCaregiverAid').value === false
            "
          >
            <img
              [src]="
                medicalForm.get('walkWithCaregiverAid').value === true
                  ? 'assets/icons/icon-carer-active.svg'
                  : 'assets/icons/icon-carer-inactive.svg'
              "
              alt="aid-3"
            /><br />
            <span
              [class.aid-active]="
                medicalForm.get('walkWithCaregiverAid').value === true
              "
              [class.aid-inactive]="
                medicalForm.get('walkWithCaregiverAid').value === false
              "
              i18n="@@patient_detail_medical_walkWithCaregiverAid"
              >aidant</span
            >
          </div>
        </div>
        <div
          class="aid"
          (click)="toggleAidWalker()"
          [class.aid-active]="medicalForm.get('walkerAid').value === true"
          [class.aid-inactive]="medicalForm.get('walkerAid').value === false"
        >
          <img
            class="icon"
            [class.uncheck-icon]="medicalForm.get('walkerAid').value === false"
            src="assets/icons/icon-walking-aid-widget-check.svg"
            alt="aid-1"
          />
          <div
            class="aid-center"
            [class.unchecked]="medicalForm.get('walkerAid').value === false"
          >
            <img
              [src]="
                medicalForm.get('walkerAid').value === true
                  ? 'assets/icons/icone-widget-aide-deambulateur-active.svg'
                  : 'assets/icons/icone-widget-aide-deambulateur-unactive.svg'
              "
              alt="aid-4"
            /><br />
            <span
              [class.aid-active]="medicalForm.get('walkerAid').value === true"
              [class.aid-inactive]="
                medicalForm.get('walkerAid').value === false
              "
              i18n="@@patient_detail_medical_walkerAid"
              >déambulateur</span
            >
          </div>
        </div>
        <div
          class="aid"
          (click)="toggleAidWheelchair()"
          [class.aid-active]="medicalForm.get('wheelChairAid').value === true"
          [class.aid-inactive]="
            medicalForm.get('wheelChairAid').value === false
          "
        >
          <img
            class="icon"
            [class.uncheck-icon]="
              medicalForm.get('wheelChairAid').value === false
            "
            src="assets/icons/icon-walking-aid-widget-check.svg"
            alt="aid-1"
          />
          <div
            class="aid-center"
            [class.unchecked]="medicalForm.get('wheelChairAid').value === false"
          >
            <img
              [src]="
                medicalForm.get('wheelChairAid').value === true
                  ? 'assets/icons/icone-widget-aide-fauteuil-roulant-active.svg'
                  : 'assets/icons/icone-widget-aide-fauteuil-roulant-unactive.svg'
              "
              alt="aid-5"
            /><br />
            <span
              [class.aid-active]="
                medicalForm.get('wheelChairAid').value === true
              "
              [class.aid-inactive]="
                medicalForm.get('wheelChairAid').value === false
              "
              i18n="@@patient_detail_medical_wheelChairAid"
              >fauteuil roulant</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="row card-info">
      <h3 class="mb-3 subtitle">
        <span i18n="@@patient_detail_medical_title_factor"
          >Facteurs de risques secondaires</span
        >
      </h3>
      <div class="subtitle-factors">
        <span i18n="@@patient_detail_medical_title_disease"
          >Existence de maladies neurologiques dans le cadre familial</span
        >
      </div>
      <div class="btn-group btn-group-toggle form-group checkbox-group">
        <label
          formArrayName="geneticRiskFactors"
          class="checkbox-form btn"
          ngbButtonLabel
          [class.active]="
            medicalForm.get('geneticRiskFactors').value[i] === true ||
            medicalForm.get('geneticRiskFactors').value[i] === 'true'
          "
          *ngFor="
            let geneticRisk of geneticRisksFormArray.controls;
            let i = index
          "
        >
          <input
            type="checkbox"
            [formControlName]="i"
            ngbButton
            [value]="geneticRisks[i]"
          />
          {{ geneticRiskMapping[geneticRisks[i]] }}
        </label>
      </div>
      <div class="subtitle-factors">
        <span i18n="@@patient_detail_medical_personalfactor"
          >Facteurs personnels</span
        >
      </div>
      <div class="btn-group btn-group-toggle form-group checkbox-group">
        <label
          formArrayName="otherRiskFactors"
          class="checkbox-form btn"
          ngbButtonLabel
          [class.active]="
            medicalForm.get('otherRiskFactors').value[i] === true ||
            medicalForm.get('otherRiskFactors').value[i] === 'true'
          "
          *ngFor="let risk of otherRisksFormArray.controls; let i = index"
        >
          <input
            type="checkbox"
            [formControlName]="i"
            ngbButton
            [value]="otherRisks[i]"
          />
          {{ otherRiskMapping[otherRisks[i]] }}
        </label>
      </div>
    </div>
  </form>
</div>
